import { getCookie } from "./app.utils";

const logoutUri = `${window.origin}/logout`;

require("es6-promise").polyfill();
require("isomorphic-fetch");

const xsrfToken = window.parent.document.getElementById("csrf-token")
  ? window.parent.document.getElementById("csrf-token").getAttribute("content")
  : getCookie("XSRF-TOKEN");

const xsrfTokenHeader = window.parent.document.getElementById("csrf-token")
  ? window.parent.document.getElementById("csrf-header").getAttribute("content")
  : "X-XSRF-TOKEN";

const message = "Something went wrong. Please try again in a bit";

const createUrlParams = params => {
  const esc = encodeURIComponent;
  const query = Object.keys(params)
    .map(k => esc(k) + "=" + esc(params[k]))
    .join("&");

  return query;
};

export const basicHeader = {
  "Content-Type": "application/json"
};

export const handleResponse = response => {
  const contentType = response.headers.get("content-type");
  if (response.ok && response.status === 200) {
    return response.json();
  } else if (response.ok && response.status === 201) {
    if (contentType && contentType.indexOf("application/json") !== -1) {
      return response.json();
    } else {
      return response.text();
    }
  } else if (response.ok && response.status === 204) {
    return null;
  }

  return response &&
    contentType &&
    contentType.indexOf("application/json") !== -1
    ? response.json().then(json => {
        if (process.env.NODE_ENV === "production") {
          if (json.code === 440) {
            window.parent.location.replace(logoutUri);
          }
        }
        const error = new CustomError(json.description || json.responseMessage || message, json.errors);
        return Promise.reject(Object.assign(error, { response }));
      })
    : Promise.reject(Object.assign(new Error(message), { response }));
};

class CustomError extends Error {
  constructor(message, errors) {
    super(message);
    this.errors = errors;
  }
}

export const apiCall = (requestType, url, requestBody, requestParams) => {
  let headers = { ...basicHeader };
  if (xsrfToken && xsrfTokenHeader) {
    headers[xsrfTokenHeader] = xsrfToken;
  }
  const requestOptions = {
    method: requestType,
    headers,
    body: requestBody ? JSON.stringify(requestBody) : undefined
  };
  if (requestParams) {
    const urlParams = createUrlParams(requestParams);
    url = `${url}?${urlParams}`;
  }
  return fetch(url, requestOptions).then(handleResponse);
};
